import config from './default'
let args = process.env.args ? process.env.args : {}
if (typeof args === 'string') {
  args = JSON.parse(args)
}
let file = args.config || args.env
let envConfig
try {
  envConfig = require('./' + file)
} catch (e) {}
let customConfig = envConfig ? envConfig.default : {}
export default Object.assign({}, config, customConfig, args)



// WEBPACK FOOTER //
// ./src/configs/index.js